import React from 'react';
import styles from './index.module.scss'
import EmptyIcon from '../icons/EmptyIcon';
import cn from 'classnames';
import { t } from "i18next";

const EmptyContent = () => {
  return (
    <div className={cn("text-center mb-4", styles.wrapper)}>
      <EmptyIcon/>
      <div className={styles.empty_text}>{t('common.emptyContentText')}</div>
    </div>
  );
};

export default EmptyContent;